import * as ActionConfigurationManager from './config.actions'

export const saveSliceRateMapping = ActionConfigurationManager.SAVE_SLICE_RATE_MAPPING
export const rehydrateSliceRateMapping = ActionConfigurationManager.REHYDRATE_SLICE_RATE_MAPPING